import { Link, Navigate, Route, Routes } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { authDisabled, loginRequest } from './auth/authConfig';
import NewPosterPage from './pages/NewPosterPage';
import TournamentsPage from './pages/TournamentsPage';
import TournamentDetailPage from './pages/TournamentDetailPage';

export default function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const signedIn = authDisabled || isAuthenticated;

  return (
    <div className="app">
      <header className="app__header">
        <Link to="/" className="brand">
          <span className="brand__mark" aria-hidden="true" />
          <span>
            <strong>Bowls Poster Generator</strong>
            <small>Match posters for Facebook, Instagram and WhatsApp</small>
          </span>
        </Link>

        <div className="app__account">
          {authDisabled && <span className="pill pill--warning">Local mode - auth disabled</span>}
          {!authDisabled && signedIn && (
            <>
              <span className="app__user">{accounts[0]?.username}</span>
              <button
                type="button"
                className="button button--ghost"
                onClick={() => void instance.logoutRedirect()}
              >
                Sign out
              </button>
            </>
          )}
        </div>
      </header>

      <main className="app__main">
        {signedIn ? (
          <Routes>
            <Route path="/" element={<TournamentsPage />} />
            <Route path="/posters/new" element={<NewPosterPage />} />
            <Route path="/tournaments/:tournamentId" element={<TournamentDetailPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          <section className="signin">
            <h1>Sign in to make posters</h1>
            <p>
              Use your club Microsoft account. Only members who have been granted access to the app
              registration can create posters.
            </p>
            <button
              type="button"
              className="button button--primary"
              onClick={() => void instance.loginRedirect(loginRequest)}
            >
              Sign in with Microsoft
            </button>
          </section>
        )}
      </main>

      <footer className="app__footer">
        Posters are generated from your core background image. Check names and dates before posting.
      </footer>
    </div>
  );
}
